import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRole } from '../../contexts/RoleContext';
import { SubscriptionModal } from '../modals';
import TabbedProductionDashboard from '../dashboard/TabbedProductionDashboard';

const Dashboard = () => {
  const { isPro } = useRole();
  const navigate = useNavigate();
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(!isPro());

  // If user is pro, show the dashboard
  if (isPro()) {
    return <TabbedProductionDashboard />;
  }

  // If user is not pro, show subscription modal
  return (
    <SubscriptionModal
      open={showSubscriptionModal}
      onClose={() => {
        // Navigate back to profile when modal is closed
        navigate('/profile');
      }}
      onUpgrade={() => {
        setShowSubscriptionModal(false);
      }}
    />
  );
};

export default Dashboard; 